import React from "react";
import searchIcon from '../../../assets/search.png';
import menuIcon from '../../../assets/menu.png';
import { RxCross1 } from "react-icons/rx";
import { useDispatch } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { LogoutUserFunc } from "../../../redux/actions/User";
import { VscMenu } from "react-icons/vsc";

const MobileNavbar = ({
  showmenu,
  setshowmenu,
  searchFunction,
  search,
  setSearch,
  user,
  data,
  UserAvatar,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <div
      className={`${
        showmenu ? "mobileHeader header_menus" : "header_menus"
      }  bg-white text-black py-2 px-2 overflow-y-auto !z-[999999999999999999]`}
    >
      <RxCross1
        className="cross_burger absolute top-5 right-5 text-[23px] cursor-pointer  hidden"
        onClick={() => setshowmenu(false)}
      />
      <div className="searchbarbox my-4  flex w-full justify-start place-items-center rounded-[10px] gap-2 py-[15px] px-3">
        <img
          src={searchIcon}
          alt="search"
          className="w-[20px] h-[20px] cursor-pointer"
          onClick={() => searchFunction()}
        />
        <input
          className="bg-transparent outline-none text-color5 w-full"
          type="text"
          placeholder="Search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              navigate(`tickets/${search}`);
              setshowmenu(false);
            }
          }}
        />
      </div>
      {/* // profile picture  */}

      <div className="hidden border-b-[1px] border-b-shadowColor my-5 !w-[100%] justify-start place-items-center gap-1 login_mobile">
        {Object.keys(user).length === 0 ? (
          <NavLink className="!w-[100%] block" to="/login" onClick={() => setshowmenu(false)}>
            <button className="!w-[100%] items-center !bg-redColor   hover:text-color1 py-3 px-3 focus:outline-none hover:bg-gray-200 rounded text-base mt-4 md:mt-0">
              SignIn / SignUp
            </button>
            <VscMenu className="text-[23px] cursor-pointer  hidden " />
          </NavLink>
        ) : (
          <div className="flex justify-between w-[100%]">
            <div>
            {user && user?.Avatar ? (
              <>
                <NavLink
                  to="/user/profile"
                  onClick={() => setshowmenu(false)}
                  className="flex justify-start !place-items-center text-color2"
                >
                  <div className="!w-[80px] !h-[80px] flex justify-center place-items-center">
                    {user?.firstName && user?.Avatar && (
                      <img
                        src={UserAvatar}
                        className="!w-[60px] !h-[60px] rounded-full border-[1px] border-redColor"
                        alt=""
                      />
                    )}
                  </div>
                  <h2 className="mx-1 !text-[20px] !text-black">
                    {user?.firstName}
                  </h2>
                </NavLink>
              </>
            ) : (
              <NavLink
                to="/user/profile"
                className=" flex justify-start !place-items-center text-color2"
                onClick={() => setshowmenu(false)}
              >
                <p
                  onClick={() => setshowmenu(false)}
                  className="border-[1px] uppercase border-redColor rounded-full p-3 h-[60px] w-[60px] flex justify-center place-items-center bg-color1 text-[white] font-bold"
                >
                  {user?.firstName?.slice(0, 1)}
                </p>
                <h2 className="mx-1 !text-[20px] !text-color2">
                  {user?.firstName}
                </h2>
              </NavLink>
            )}
            </div>
            {user && user?.firstName && (
              <button
                className="my-4 py-2 px-3 border-[1px] border-redColor bg-redColor text-white rounded-md w-[120px]"
                onClick={() => dispatch(LogoutUserFunc(navigate))}
              >
                Logout
              </button>
            )}
          </div>
        )}
      </div>

      {/* =================  */}
      
      <nav className="md:ml-auto flex flex-wrap items-center text-base justify-center sidebar_nav ">
        {/* Create New Event Button - Only show when user is logged in and is an organizer */}
        {user && user?.firstName && (
          <NavLink
            to="/create-event"
            className="mr-5 mb-4 w-full"
            onClick={() => setshowmenu(false)}
          >
            <button className="create-event-btn-mobile bg-[#DF3331] text-white px-[20px] py-[12px] rounded-[25px] border-none cursor-pointer flex items-center justify-center gap-[8px] font-unbounded font-medium text-[14px] hover:bg-[#c42d2b] transition-colors duration-200 w-full">
              <span className="text-[16px]">+</span>
              Create New Event
            </button>
          </NavLink>
        )}

        <NavLink
          to={"/"}
          className={`mr-5 hover:text-redColor active:text-[red]`}
          onClick={() => setshowmenu(false)}
        >
          Home
        </NavLink>
        <NavLink
          to={"/tickets"}
          className={`mr-5 hover:text-redColor`}
          onClick={() => setshowmenu(false)}
        >
          All Events
        </NavLink>
        <NavLink
          onClick={() => setshowmenu(false)}
          to="/newsfeed/1"
          className={`mr-5 hover:text-redColor active:text-[red]`}
        >
          News Feed
        </NavLink>
        <NavLink
          to={"/aboutUs"}
          className={`mr-5 hover:text-redColor active:text-[red]`}
          onClick={() => setshowmenu(false)}
        >
          About Us
        </NavLink>
        <a>
          {user && user?.email && (
            <div>
              <li className="list-none " onClick={() =>{
                navigate("/my-tickets");
                setshowmenu(false)
              }}>
                My tickets
              </li>
            </div>
          )}
        </a>
        {/* ============ categories accordian  */}

        {data?.map((item, index) => {
          return (
            <div className="collapse collapse-plus bg-transparent" key={index}>
              <input type="radio" name="my-accordion-3" defaultChecked />
              <div className="collapse-title text-xl font-medium">
                {item?.name}
              </div>
              <div className="collapse-content bg-[#131212]">
                {item?.subCategory?.length > 0 ? (
                  item?.subCategory?.map((elem, index) => {
                    return (
                      <li
                        key={index}
                        className="hover:bg-[#131212] list-none py-2 w-[100%]"
                        onClick={() => setshowmenu(false)}
                      >
                        <NavLink
                          to={`/tickets/category=${elem?.id}`}
                          className="w-[100%] text-[grey] !border-none block"
                        >
                          {elem.name}
                        </NavLink>
                      </li>
                    );
                  })
                ) : (
                  <div className="new_category_box shrink-0 w-[100%] hover:border-b-2 hover:border-b-redColor cursor-pointer">
                    <p className="w-[100%] text-center">
                      No more category found
                    </p>
                  </div>
                )}
              </div>
            </div>
          );
        })}

        {/* ==========================  */}
      </nav>
      {/* =====  */}
    </div>
  );
};

export default MobileNavbar;
